import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { GenericModal } from '../components/Modal';
import { ZipFileExplorer } from '../components/ZipFileExplorer';

interface renderOpenProps {
  fileId: string
  params?: {[key: string]: string}
}

const useZipFileExplorerPopUp = () => {
  // modal
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [fileId, setFileId] = useState<string>('');
  const [query, setQuery] = useState<{[key: string]: string}>({});
  const openFileExplorer = (id: string, _query?: {[key: string]: string}) => {
    setFileId(id);
    setIsModalOpen(true);
    setQuery(_query || {});
  };

  return {
    openFileExplorer,

    renderOpenLink(props: renderOpenProps) {
      return (
        <Link
          to={`/admin/files/browser/${props.fileId}`}
          target="_blank"
          onClick={e => {
            e.preventDefault();
            openFileExplorer(props.fileId, props.params);
          }}>
          Open File Explorer
        </Link>
      );
    },

    renderOpenButton(props: renderOpenProps) {
      return (
        <Button
          className="mr-1"
          type="button"
          size="small"
          onClick={() => openFileExplorer(props.fileId, props.params)}
          variant="outlined"
          color="primary"
        >
          Open File Explorer
        </Button>
      );
    },

    renderModal() {
      return (
        <GenericModal
          size={1800}
          fixExpand={true}
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          footer={(
            <div className="text-right">
              <Button
                className="mr-1"
                type="button"
                size="small"
                onClick={() => setIsModalOpen(false)}
                variant="outlined"
                color="primary"
              >
                Close
              </Button>
            </div>
          )}
        >
          <div className="w-100 h-100 position-relative">
            <ZipFileExplorer fileId={fileId} query={query} />
          </div>
        </GenericModal>
      );
    }
  };
};

export default useZipFileExplorerPopUp;
